import axios from '../../../axios.conf';
import secureLocalStorage from 'react-secure-storage';
import { toast } from 'react-toastify';
import { history } from '../../../components/Helpers';
import { handleExecutionLog } from '../../../components/ExecutionLogHandler';
import { runExecuteQuery } from '../Simulations/OperationalReports/AuthAction';
import { FETCH_START, FETCH_END, COMPREHENCIVE_QUOTE_DATA, COMPREHENCIVE_QUOTE_DATA_BY_ID } from '../Pricing/ActionTypes';
import { QUOTE_CONFIGURATION_SUCCESS } from './ActionTypes';

const fetchStart = () => ({ type: FETCH_START });
const fetchEnd = () => ({ type: FETCH_END });

// ── Comprehensive Quote List ───────────────────────────────────────────────

export const getComprehensiveQuote = () => {
  const data = { query_name: 'Ima_cpq_quote_list' };
  return async (dispatch) => {
    if (!data) return;
    try {
      const response = await dispatch(runExecuteQuery(data));
      if (!response) throw new Error('Empty response');
      dispatch(getComprehensiveQuoteSuccess(response.data.response));
    } catch (error) {

    }
  };
};

export const getComprehensiveQuoteSuccess = (data) => ({
  type: COMPREHENCIVE_QUOTE_DATA,
  data,
});

export const getComprehensiveQuoteById = (id, type) => {
  return (dispatch) => {
    return getComprehensiveQuoteByIdAPI(id, type)
      .then((response) => {
        if (type == 'delete') dispatch(getComprehensiveQuote());
        else dispatch(getComprehensiveQuoteByIdSuccess(response.data.response));
        return response;
      })
      .catch((error) => {
        return { success: false, error };
      });
  };
};

const getComprehensiveQuoteByIdAPI = (id, type) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  if (type === 'delete') return axios.delete('pricing/quote/' + id, { headers });
  return axios.get('pricing/quote/' + id, { headers });
};

export const getComprehensiveQuoteByIdSuccess = (data) => ({
  type: COMPREHENCIVE_QUOTE_DATA_BY_ID,
  data,
});

// ── Comprehensive Quote ────────────────────────────────────────────────────

export const createComprehensiveQuote = (data, mode, type) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await createComprehensiveQuoteAPI(data, mode);
      dispatch(fetchEnd());
      const logNumber = response?.data?.log_number;
      if (logNumber) {
        await handleExecutionLog(dispatch, logNumber);
      }
      if (type !== 'commit') {
        history.push('/price-comprehensive-quote');
        dispatch(getComprehensiveQuote());
        toast.success(response?.data?.response?.status);
      } else {
        dispatch({ type: COMPREHENCIVE_QUOTE_DATA_BY_ID, data: response?.data?.response });
      }
    } catch (error) {
      dispatch(fetchEnd());
      const logNumber = error.response?.data?.log_number;
      if (logNumber) {
        await handleExecutionLog(dispatch, logNumber);
      }
    }
  };
};

const createComprehensiveQuoteAPI = (data, mode) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  return axios.post('pricing/quote', data, { headers });
};



// ── Quote Configuration ────────────────────────────────────────────────────

export const getQuoteConfiguration = (quoteType) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getQuoteConfigurationAPI(quoteType)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getQuoteConfigurationSuccess(response?.data?.response));
      })
      .catch(() => {
        dispatch(fetchEnd());
      });
  };
};

const getQuoteConfigurationAPI = (quoteType) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  if (quoteType) {
    return axios.get('pricing/quote-configuration/' + quoteType, { headers });
  }
  return axios.get('pricing/quote-configuration', { headers });
};

export const getQuoteConfigurationSuccess = (data) => ({
  type: QUOTE_CONFIGURATION_SUCCESS,
  data,
});

export const createQuoteConfiguration = (data, quoteType, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createQuoteConfigurationAPI(data, quoteType, type)
      .then((response) => {
        dispatch(fetchEnd());
        if (type === 'delete') {
          dispatch(getQuoteConfiguration());
          toast.success(response.data.message);
        } else {
          history.push('/quote-configuration');
          toast.success(response.data.message);
        }
      })
      .catch(() => {
        dispatch(fetchEnd());
      });
  };
};

const createQuoteConfigurationAPI = (data, quoteType, type) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  if (type === 'update') {
    return axios.put('pricing/quote-configuration/' + quoteType, data, { headers });
  } else if (type === 'delete') {
    return axios.delete('pricing/quote-configuration/' + quoteType, { headers });
  }
  return axios.post('pricing/quote-configuration', data, { headers });
};
